const serviceRequestIcon = './assets/icons/service-request/room_service_black_24dp.svg';
const bedIcon = './assets/icons/service-request/bed_black_24dp.svg';
const laundryIcon = './assets/icons/service-request/local_laundry_service_black_24dp.svg';
const towelIcon = './assets/icons/service-request/Page-1.svg';
const bathroomIcon = './assets/icons/service-request/cleanser.svg';
const dryerIcon = './assets/icons/service-request/noun-blower-3972012.svg';
const repairIcon = './assets/icons/service-request/home_repair_service_black_24dp.svg';
const ironIcon = './assets/icons/service-request/iron_black_24dp.svg';
const cafeIcon = './assets/icons/service-request/local_cafe_black_24dp.svg';
const childIcon = './assets/icons/service-request/child_care_black_24dp.svg';
const blanketIcon = './assets/icons/service-request/blanket.svg';
const barIcon = './assets/icons/service-request/local_bar_black_24dp.svg';
const petIcon = './assets/icons/service-request/pets_black_24dp.svg';
const reminderIcon = './assets/icons/service-request/event_available_black_24dp.svg';
const taxiIcon = './assets/icons/service-request/local_taxi_black_24dp.svg';
const mapIcon = './assets/icons/service-request/map_black_24dp.svg';
const shoppingIcon = './assets/icons/service-request/shopping_bag_black_24dp.svg';
const maintainanceIcon = './assets/icons/service-request/handyman_black_24dp.svg';
const medicalIcon = './assets/icons/service-request/medical_services_black_24dp.svg';
const bellIcon = './assets/icons/service-request/notifications_black_24dp.svg';
const foodIcon = './assets/icons/service-request/restaurant_black_24dp.svg';
const spaIcon = './assets/icons/service-request/spa_black_24dp.svg';
const housekepingIcon = './assets/icons/service-request/mop.svg';
const conciergeIcon = './assets/icons/service-request/bellboy.svg';
const emergencyIcon = './assets/icons/service-request/alert.svg';
const gymIcon = './assets/icons/service-request/fitness_center_black_24dp.svg';
const amenitiesFacilitieIcon = './assets/icons/service-request/featured.svg';
const deskIcon = './assets/icons/service-request/counter.svg';
const casinoIcon = './assets/icons/service-request/ace-of-spades.svg';
const additionalRequestIcon = './assets/icons/service-request/aditional_request.svg';
const assistanceIcon = './assets/icons/service-request/assistance.svg';

export const HOUSE_KEEPING = 'HOUSE_KEEPING';
export const CONCIERGE = 'CONCIERGE';

export const HOUSEKEEPING_CREATE = 'HOUSEKEEPING_CREATE';
export const CONCIERGE_CREATE = 'CONCIERGE_CREATE';

export const HOUSEKEEPING_VIEW = 'HOUSEKEEPING_VIEW';
export const CONCIERGE_VIEW = 'CONCIERGE_VIEW';

export const HOUSEKEEPING_EDIT = 'HOUSEKEEPING_EDIT';
export const CONCIERGE_EDIT = 'CONCIERGE_EDIT';

export const HOUSEKEEPING_TYPE = 'HOUSEKEEPING_TYPE';
export const CONCIERGE_TYPE = 'CONCIERGE_TYPE';

export const HOUSE_KEEPING_TAB_LIST = ['Details', 'Items', 'Hours', 'Media'];

export const housekeepingServiceIconOptions = [
  { id: 'Other Services', name: 'Other Services', url: serviceRequestIcon },
  { id: 'Make up room', name: 'Make up room', url: bedIcon },
  { id: 'Laundry', name: 'Laundry', url: laundryIcon },
  { id: 'Towels', name: 'Towels', url: towelIcon },
  { id: 'Bathroom Amenities', name: 'Bathroom Amenities', url: bathroomIcon },
  { id: 'Room Amenities', name: 'Room Amenities', url: dryerIcon },
  { id: 'Kit', name: 'Kit', url: repairIcon },
  { id: 'Iron & Iron Board', name: 'Iron & Iron Board', url: ironIcon },
  { id: 'Tea / Coffee Amenities', name: 'Tea / Coffee Amenities', url: cafeIcon },
  { id: 'Bed', name: 'Bed', url: bedIcon },
  { id: 'Kid', name: 'Kid', url: childIcon },
  { id: 'Blanket', name: 'Blanket', url: blanketIcon },
  { id: 'Minibar', name: 'Minibar', url: barIcon },
  { id: 'Pet', name: 'Pet', url: petIcon },
  { id: 'Additional item Request', name: 'Additional item Request', url: additionalRequestIcon },
  { id: 'Room Assistance', name: 'Room Assistance', url: assistanceIcon },
  { id: 'In Room Items - Shopping', name: 'In Room Items - Shopping', url: shoppingIcon },
];

export const conciergeServiceIconOptions = [
  { id: 'Other Services', name: 'Other Services', url: serviceRequestIcon },
  { id: 'Reservations', name: 'Reservations', url: reminderIcon },
  { id: 'Transportation', name: 'Transportation', url: taxiIcon },
  { id: 'City Guide', name: 'City Guide', url: mapIcon },
  { id: 'Shopping', name: 'Shopping', url: shoppingIcon },
  { id: 'Maintenance', name: 'Maintenance', url: maintainanceIcon },
  { id: 'Medical', name: 'Medical', url: medicalIcon },
  { id: 'Reminders', name: 'Reminders', url: bellIcon },
  { id: 'Pet', name: 'Pet', url: petIcon },
];

export const SCHEDULE_STATUS_ACTIVE = 'Active';

export const itemConsts = [
  'itemDescription',
  'itemId',
  'itemMaxQuantity',
  'itemQuantity',
  'itemName',
  'itemDataType',
];

export const hoursConsts = ['from', 'to', 'availableOn', 'hours'];

export const TELEPHONY_DIRECTORY = 'TELEPHONY_DIRECTORY';
export const TELEPHONY_EXTENSIONS = 'TELEPHONY_EXTENSIONS';

export const TELEPHONY_DIRECTORY_CREATE = 'TELEPHONY_DIRECTORY_CREATE';
export const TELEPHONY_EXTENSIONS_CREATE = 'TELEPHONY_EXTENSIONS_CREATE';

export const TELEPHONY_DIRECTORY_VIEW = 'TELEPHONY_DIRECTORY_VIEW';
export const TELEPHONY_EXTENSIONS_VIEW = 'TELEPHONY_EXTENSIONS_VIEW';

export const TELEPHONY_DIRECTORY_EDIT = 'TELEPHONY_DIRECTORY_EDIT';
export const TELEPHONY_EXTENSIONS_EDIT = 'TELEPHONY_EXTENSIONS_EDIT';

export const TELEPHONY_DIRECTORY_TYPE = 'TELEPHONY_DIRECTORY_TYPE';
export const TELEPHONY_EXTENSIONS_TYPE = 'TELEPHONY_EXTENSIONS_TYPE';

export const TELEPHONY_DIRECTORY_ICON_OPTIONS = [
  { id: 'Other Services', name: 'Other Services', url: serviceRequestIcon },
  { id: 'Food', name: 'Food', url: foodIcon },
  { id: 'Spa', name: 'Spa', url: spaIcon },
  { id: 'Housekeeping', name: 'Housekeeping', url: housekepingIcon },
  { id: 'Concierge', name: 'Concierge', url: conciergeIcon },
  { id: 'Maintenance/Repair', name: 'Maintenance/Repair', url: maintainanceIcon },
  { id: 'Medical', name: 'Medical', url: medicalIcon },
  { id: 'Emergency', name: 'Emergency', url: emergencyIcon },
  { id: 'Gym', name: 'Gym', url: gymIcon },
  { id: 'Amenities/Facilities', name: 'Amenities/Facilities', url: amenitiesFacilitieIcon },
  { id: 'Desk', name: 'Desk', url: deskIcon },
  { id: 'Casino', name: 'Casino', url: casinoIcon },
];

export const ITEMS_COUNT = 50;

export const ITEM_DATA_TYPE_OPTIONS = [
  { id: 'text', name: 'Text' },
];
